import Vue from 'vue';
export const GTR_EVENT_KEYS = {
  useBreadcrumb: 'useBreadcrumb',
};
export default new Vue();
